import { render } from "./ShipmentTracking.vue?vue&type=template&id=41073d63&scoped=true"
import script from "./ShipmentTracking.vue?vue&type=script&lang=js"
export * from "./ShipmentTracking.vue?vue&type=script&lang=js"

import "./ShipmentTracking.vue?vue&type=style&index=0&id=41073d63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41073d63"]])

export default __exports__